module.exports = __webpack_public_path__ + "img/13.44c465a0.svg";